import './main.less';
import React from 'react';
import Order from '../../shared/order-list/main';

const Main = props => {
	return (
		<div className="container__content programs-list">
			<div className="table-container">
				<table className="simple-table offers-table additional-offers-table">
					<thead className="simple-table__head font-roboto-medium">
						<tr>
							<th>
								Location
								<p className="order-action-btn order-action-btn--reorder">
									<span onClick={props.toggleReorder}>Reorder</span>
								</p>
								<p className="order-action-btn order-action-btn--reorder width-150">
									<span onClick={props.saveOrder}>Save</span>
								</p>
							</th>
						</tr>
					</thead>
					<tbody className="simple-table__body">
						<Order onSortEnd={props.saveReorder}>
							{
								props.rows.map((row, index) =>
									<Order.Item key={index} id={row.country_code}>
										<tr className="width-100-p display-inline-block hover-pointer">
											<td>{row.country_name}</td>
										</tr>
									</Order.Item>)
							}
						</Order>
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default Main;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/locations-plan/reorder-table.js